import React from 'react';
import { Stations } from '@/features/properties/components/Stations';

/**
 * 物件検索
 * @returns
 */

function Page() {
  return (
    <>
      <Stations searchPath="/property" />
    </>
  );
}

export default Page;
